"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _save = /*#__PURE__*/ _interop_require_default(require("./save"));
var _load = /*#__PURE__*/ _interop_require_default(require("./load"));
var _remove = /*#__PURE__*/ _interop_require_default(require("./remove"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
require("./polyfill");
module.exports = {
    load: _load.default,
    save: _save.default,
    remove: _remove.default
};
